import { navegadorDentroDeApp } from './tiendanubeConexionLogica';

/**
 * Red de seguridad del retorno de Google en `/auth`
 * (ADR-2026-10-15-el-login-con-google-no-espera-a-otras-pestanas).
 *
 * Google vuelve a `/auth#access_token=…` y supabase-js procesa el hash y lo borra. Si la
 * pantalla sigue con el token en la URL y sin sesión pasado un rato, el ingreso se trabó en
 * este navegador: sin aviso, el usuario ve el login como si nada y reintenta en loop.
 */

/** Cuánto se espera al retorno antes de avisar. Un retorno sano entra en 1-2 s. */
export const MS_ESPERA_RETORNO_DE_GOOGLE = 6000;

/** La URL trae el token con el que vuelve Google (flujo implícito). */
export function volvioConTokenDeOAuth(hash: string | null | undefined): boolean {
  return /[#&]access_token=/.test(hash ?? '');
}

/** Qué decirle al usuario según dónde está: en el navegador de una app, o en uno común. */
export function avisoDeRetornoTrabado(userAgent: string | null | undefined): {
  titulo: string;
  detalle: string;
} {
  const app = navegadorDentroDeApp(userAgent);
  return {
    titulo: 'No pudimos terminar de entrar con Google',
    detalle: app
      ? `Estás usando el navegador de ${app}. Abrí Atlas en Safari o Chrome y entrá desde ahí.`
      : 'Cerrá las otras pestañas de Atlas y volvé a intentar. Si sigue, abrí Atlas en Safari o Chrome.',
  };
}
